import betSoundUrl from '../assets/audio/bet.mp3?url'
import bombSoundUrl from '../assets/audio/bomb.mp3?url'
import gemSoundUrl from '../assets/audio/gem.mp3?url'
import winSoundUrl from '../assets/audio/win.mp3?url'

export type MineSoundKey = 'bet' | 'gemReveal' | 'mineExplosion' | 'win'

const SFX_DEFAULT_VOLUME = 0.5

export class SoundManager {
	private static _instance: SoundManager | null = null
	private isMuted = false
	private loaded = false
	private volume = SFX_DEFAULT_VOLUME
	private readonly sources: Record<MineSoundKey, string> = {
		bet: betSoundUrl,
		gemReveal: gemSoundUrl,
		mineExplosion: bombSoundUrl,
		win: winSoundUrl,
	}

	static get instance() {
		if (!this._instance) {
			this._instance = new SoundManager()
		}

		return this._instance
	}

	async load() {
		if (this.loaded) {
			return
		}

		await Promise.all(
			Object.values(this.sources).map(
				(src) =>
					new Promise<void>((resolve) => {
						const audio = new Audio(src)
						audio.preload = 'auto'
						audio.oncanplaythrough = () => resolve()
						audio.onerror = () => resolve()
					}),
			),
		)

		this.loaded = true
	}

	play(key: MineSoundKey) {
		if (this.isMuted) {
			return
		}

		const src = this.sources[key]
		if (!src) {
			return
		}

		try {
			const audio = new Audio(src)
			audio.volume = this.volume
			void audio.play().catch(() => undefined)
		} catch {
			// Audio unavailable.
		}
	}

	stopAll() {
		// Cloned audio elements stop automatically.
	}

	mute() {
		this.isMuted = true
	}

	unmute() {
		this.isMuted = false
	}
}
